unit LocationType;
{

/* Initail. */

}
interface

uses
  JS,
  DepartmentType;

type
  TLocationType = class
  private
    fLocationKey: String;
    fName: String;
    fDepartment: TDepartmentType;
    fActive: Boolean;
  public
    property LocationKey: String read fLocationKey;
    property Name: String read fName;
    property Department: TDepartmentType read fDepartment;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TLocationType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fLocationKey := String(JSObject_Type['locationKey']);
    fName := String(JSObject_Type['name']);
    fDepartment := TDepartmentType.Create(TJSJSON.stringify(JSObject_Type['department']));
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
